import { render, staticRenderFns } from "./demonstrationBaseList.vue?vue&type=template&id=9b3743da&scoped=true&"
import script from "./demonstrationBaseList.vue?vue&type=script&lang=js&"
export * from "./demonstrationBaseList.vue?vue&type=script&lang=js&"
import style0 from "./demonstrationBaseList.vue?vue&type=style&index=0&id=9b3743da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3743da",
  null
  
)

export default component.exports